import { SearchInput } from 'react-admin';

const SearchFields = [
  <SearchInput
    source="q"
    alwaysOn
    color="info"
    className="bhvk-list-search-input"
  />,
];

export default SearchFields;
